import React from 'react';

const serviceData = [
    {
        icon: 'laptop',
        title: 'Web Development',
        description: 'Crafting responsive and user-friendly websites tailored to your needs.',
        color: 'text-bilih-blue'
    },
    {
        icon: 'smartphone',
        title: 'Mobile Apps',
        description: 'Developing innovative mobile applications for iOS and Android platforms.',
        color: 'text-bilih-green'
    },
    {
        icon: 'message-circle',
        title: 'Telegram Bots',
        description: 'Creating intelligent and interactive Telegram bots for various purposes.',
        color: 'text-bilih-yellow'
    },
    {
        icon: 'settings',
        title: 'Automation Services',
        description: 'Streamlining your business processes with cutting-edge automation solutions.',
        color: 'text-bilih-red'
    }
];

function Services() {
    return (
        <section id="services" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">Our Services</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {serviceData.map((service, index) => (
                        <div key={index} className="service-card bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
                            <div className={`text-4xl mb-4 ${service.color}`}>
                                <i className={`feather icon-${service.icon}`}></i>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                            <p className="text-gray-600">{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Services;